import React from 'react';
import TeamAnalyser from '../components/TeamAnalyser';
import Pageheader from '../utils/headerHelment';

const TeamAnalyserPage = () => {
    return (
        <>
            <Pageheader title="LENS - Team Analyser" />
            <TeamAnalyser />
        </>
    );
};

export default TeamAnalyserPage;
